// This file is auto-generated. Do not edit!

export default [
  {
    name: "bb-WETH-wstETH",
    id: "0",
    bpt: "0xbAd20c15A773bf03ab973302F61FAbceA5101f0A",
    tokens: [
      {
        address: "0x6A023CCd1ff6F2045C3309768eAd9E68F978f6e1",
        symbol: "WETH",
      },
      {
        address: "0x6C76971f98945AE98dD7d4DFcA8711ebea946eA6",
        symbol: "wstETH",
      },
    ],
    rewarder: "0x026d163C28cC7dbf57d6ED57f14208Ee412CA526",
  },
  {
    name: "50COW-50GNO",
    id: "5",
    bpt: "0x21d4c792Ea7E38e0D0819c2011A2b1Cb7252Bd99",
    tokens: [
      {
        address: "0x177127622c4A00F3d409B75571e12cB3c8973d3c",
        symbol: "COW",
      },
      {
        address: "0x9C58BAcC331c9aa871AFD802DB6379a98e80CEdb",
        symbol: "GNO",
      },
    ],
    rewarder: "0x8B59F9d4F24A266630756131fE62C3476886e496",
  },
  {
    name: "B-50wstETH-50GNO",
    id: "15",
    bpt: "0x4683e340a8049261057D5aB1b29C8d840E75695e",
    tokens: [
      {
        address: "0x6C76971f98945AE98dD7d4DFcA8711ebea946eA6",
        symbol: "wstETH",
      },
      {
        address: "0x9C58BAcC331c9aa871AFD802DB6379a98e80CEdb",
        symbol: "GNO",
      },
    ],
    rewarder: "0x14A81C9283CC16897DaA3f466847Baa260b770eB",
  },
  {
    name: "B-50wstETH-25BAL-25AURA",
    id: "17",
    bpt: "0x00dF7f58e1Cf932eBe5f54De5970Fb2Bdf0ef06D",
    tokens: [
      {
        address: "0x1509706a6c66CA549ff0cB464de88231DDBe213B",
        symbol: "AURA",
      },
      {
        address: "0x6C76971f98945AE98dD7d4DFcA8711ebea946eA6",
        symbol: "wstETH",
      },
      {
        address: "0x7eF541E2a22058048904fE5744f9c7E4C57AF717",
        symbol: "BAL",
      },
    ],
    rewarder: "0x51867537e5532186E76BA5380235512A9A4ca52a",
  },
  {
    name: "EURe/sDAI",
    id: "18",
    bpt: "0xDd439304A77f54B1F7854751Ac1169b279591Ef7",
    tokens: [
      {
        address: "0xaf204776c7245bF4147c2612BF6e5972Ee483701",
        symbol: "sDAI",
      },
      {
        address: "0xcB444e90D8198415266c6a2724b7900fb12FC56E",
        symbol: "EURe",
      },
    ],
    rewarder: "0xDE151980d461696543aa07A19BbE2603B20ECbAE",
  },
  {
    name: "B-50sDAI-50wstETH",
    id: "19",
    bpt: "0xBc2acf5E821c5c9f8667A36bB1131dAd26Ed64F9",
    tokens: [
      {
        address: "0x6C76971f98945AE98dD7d4DFcA8711ebea946eA6",
        symbol: "wstETH",
      },
      {
        address: "0xaf204776c7245bF4147c2612BF6e5972Ee483701",
        symbol: "sDAI",
      },
    ],
    rewarder: "0x49AaDc30B5cCC57bddd55aC8BD7D8DB7cf1f2b8b",
  },
  {
    name: "B-50wstETH-50COW",
    id: "20",
    bpt: "0x4cdABE9E07ca393943AcFB9286bBbd0D0a310Ff6",
    tokens: [
      {
        address: "0x177127622c4A00F3d409B75571e12cB3c8973d3c",
        symbol: "COW",
      },
      {
        address: "0x6C76971f98945AE98dD7d4DFcA8711ebea946eA6",
        symbol: "wstETH",
      },
    ],
    rewarder: "0x85298595D4F6F8Fa91f8658BA9c10f9A85B17f62",
  },
  {
    name: "ECLP-wstETH-WETH",
    id: "25",
    bpt: "0x8DD4df4Ce580b9644437f3375e54f1ab09808228",
    tokens: [
      {
        address: "0x6A023CCd1ff6F2045C3309768eAd9E68F978f6e1",
        symbol: "WETH",
      },
      {
        address: "0x6C76971f98945AE98dD7d4DFcA8711ebea946eA6",
        symbol: "wstETH",
      },
    ],
    rewarder: "0x6869b960599A45396E67C086C6AA5123269291FA",
  },
  {
    name: "ECLP-rETH-WETH",
    id: "26",
    bpt: "0x71E1179C5e197FA551BEEC85ca2EF8693c61b85b",
    tokens: [
      {
        address: "0x6A023CCd1ff6F2045C3309768eAd9E68F978f6e1",
        symbol: "WETH",
      },
      {
        address: "0xc791240D1F2dEf5938E2031364Ff4ed887133C3d",
        symbol: "rETH",
      },
    ],
    rewarder: "0x37748422F82b0c07CCbD40347abC1Da55ac138a0",
  },
  {
    name: "osGNO/GNO-BPT",
    id: "28",
    bpt: "0x3220C83e953186f2B9dDFc0B5dD69483354EDCA2",
    tokens: [
      {
        address: "0x9C58BAcC331c9aa871AFD802DB6379a98e80CEdb",
        symbol: "GNO",
      },
      {
        address: "0xF490c80aAE5f2616d3e3BDa2483E30C4CB21d1A0",
        symbol: "osGNO",
      },
    ],
    rewarder: "0x198F9709870d061c40ED5c08b1b09093144DdE2B",
  },
  {
    name: "ECLP-sDAI-USDC.e-rh",
    id: "30",
    bpt: "0xaa56989Be5E6267fC579919576948DB3e1F10807",
    tokens: [
      {
        address: "0xaf204776c7245bF4147c2612BF6e5972Ee483701",
        symbol: "sDAI",
      },
      {
        address: "0xf0E7eC247b918311afa054E0AEdb99d74c31b809",
        symbol: "stataGnoUSDCe",
      },
    ],
    rewarder: "0x41FaEAEC99Ca60cFc1cEd927cA93f480f040325F",
  },
] as const
